import z from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeString,
  nullSafeStringArray,
} from '../shared/schema'

export const schema = z.object({
  title: nullSafeString(''),
  description: nullSafeString(''),
  requiredPrompts: nullSafeStringArray([]),
  optionalPrompts: nullSafeStringArray([]),
  requiredFields: nullSafeStringArray([]),
  promptType: z.literal('post_room_state_prompt'),
  showTestingTab: nullSafeOptionalBoolean(false),
})

export const empty = Object.freeze(
  schema.parse({
    promptType: 'post_room_state_prompt',
  })
)

export type FirestorePromptPostRoomStateType = z.infer<typeof schema>
